module.exports = __webpack_public_path__ + "img/circle_of_sadness.12b971d8.jpg";